import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithInterceptor } from "src/utils/baseQuery";
import { OraganisationInterface } from "src/services/organisation/organisationSlice";

interface UpdateOrganisation {
  id: string;
  data: Partial<OraganisationInterface>;
}

export const OrganisationApi = createApi({
  reducerPath: "OrganisationApi",
  baseQuery: baseQueryWithInterceptor,
  tagTypes: ["Organisation"],
  endpoints: (builder) => ({
    // getOrganisationById: builder.query<OraganisationInterface, string>({
    //   query: (id) => ({
    //     headers: {
    //       "Content-type": "application/json",
    //     },
    //     url: `organization/${id}`,
    //     method: "GET",
    //   }),
    // }),
    getCompanyById: builder.query<any, string>({
      query: (id) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `company/${id}`,
        method: "GET",
      }),
    }),
    getCompanyByType: builder.query<any, { name?: string, type?: string }>({
      query: (queryParams) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `company/search`,
        method: "GET",
        params: queryParams
      }),
    }),
    getCompanyList: builder.query<any, { page?: number; limit?: number, type?: string }>({
      query: (queryParams) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `company`,
        method: "GET",
        params: queryParams
      }),
    }),
    addCompany: builder.mutation<any, void>({
      query: (data) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `company`,
        method: "POST",
        body: data
      }),
    }),
    searchCompanyByName: builder.query<any, string>({
      query: (name) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `company?name=${name}`,
        method: "GET",
      }),
    }),
    searchShippingCompanyByName: builder.query<any, string>({
      query: (name) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `company?name=${name}&type=shipping`,
        method: "GET",
      }),
    }),
    patchCompanyById: builder.mutation<any, any>({
      query: ({id,data}) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `company/${id}`,
        method: "PATCH",
        body: data,
      }),
    }),
    patchOrganisationById: builder.mutation<OraganisationInterface, UpdateOrganisation >({
      query: ({ id, data }) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `organization/${id}`,
        method: "PATCH",
        body: data,
      }),
    }),
  }),
});

export const {
  useGetCompanyByIdQuery,
  useGetCompanyByTypeQuery,
  useGetCompanyListQuery,
  useSearchCompanyByNameQuery,
  useSearchShippingCompanyByNameQuery,
  usePatchCompanyByIdMutation,
  usePatchOrganisationByIdMutation,
  useAddCompanyMutation,
} = OrganisationApi;
